import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      {/* Start Footer Area */}
      <footer className="footer1">
        <div className="footer-area footer-area-2 footer-area-3">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="footer-content footer-center text-center">
                  <div className="footer-head">
                    {/* <div className="footer-logo">
                      <Link to="/">
                        <img src="/public/assets/img/logo/logo4.png" alt="Company Logo" />
                      </Link>
                    </div> */}
                    <p>
                      Helping agencies define their business objectives and create meaningful strategies.
                      We maintain clarity and focus in everything we deliver.
                    </p>
                    <div className="footer-icons">
                      <ul>
                        <li>
                          <Link to="https://www.facebook.com" target="_blank" aria-label="Facebook">
                            <i className="fa fa-facebook" />
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.twitter.com" target="_blank" aria-label="Twitter">
                            <i className="fa fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.google.com" target="_blank" aria-label="Google">
                            <i className="fa fa-google" />
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.pinterest.com" target="_blank" aria-label="Pinterest">
                            <i className="fa fa-pinterest" />
                          </Link>
                        </li>
                        <li>
                          <Link to="https://www.instagram.com" target="_blank" aria-label="Instagram">
                            <i className="fa fa-instagram" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Start Footer Bottom Area */}
        <div className="footer-area-bottom footer-area-bottom-2">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="footer-menu text-center">
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                    <li>
                      <Link to="/service">Services</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Footer Bottom Area */}
      </footer>
      {/* End Footer Area */}
    </>
  );
};

export default Footer;
